import { formatBlogDate } from "utilities/blogHelpers"

export default function BlogIntro({ date, title, author }) {
  return (
    <>
      <div className="font-primary uppercase">
        {date && date !== "" ? (
          <time className="font-primary uppercase" dateTime={date}>{`${formatBlogDate(date)}`}</time>
        ) : null}
        {author && author !== "" && date && date !== "" ? " | " : null}
        {author && author !== "" ? <div className="inline-block font-primary uppercase">{author}</div> : null}
      </div>

      {/* Semantically correct due to being wrapped in an <article> tag - for seo/a11y */}
      <h1 className="text-m2 font-primary font-normal pb-8 pt-1">{title}</h1>
    </>
  )
}
